// import { useState } from 'react';
// import { Pill } from 'lucide-react';
// import { Button } from '@workspace/web-ui/components/button';
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from '@workspace/web-ui/components/dialog';

// type DosespotModalProps = {
//   isOpen: boolean;
//   onClose: () => void;
// };

// const DosespotModal: React.FC<DosespotModalProps> = ({ isOpen, onClose }) => {
//   return (
//     <Dialog open={isOpen} onOpenChange={onClose}>
//     <>
//       {/* Trigger Button */}
//       <Button
//         onClick={() => setIsOpen(true)}
//         className="bg-blue-600 w-full text-white px-4 py-2 rounded hover:bg-blue-700 transition flex items-center gap-2"
//       >
//         <Pill className="w-4 h-4" />
//         Assign Medication
//       </Button>

//       {/* Dialog Modal */}
//       <Dialog open={isOpen} onOpenChange={setIsOpen}>
//         <DialogContent className="w-full max-w-4xl">
//           <DialogHeader>
//             <DialogTitle>Dosespot UI</DialogTitle>
//           </DialogHeader>

//           <div className="w-full h-[70vh]">
//             <iframe
//               src="https://my.staging.dosespot.com"
//               title="Dosespot"
//               className="w-full h-full border-0"
//             />
//           </div>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default DosespotModal;


// import { Button } from '@workspace/web-ui/components/button';
// import {
//   Dialog,
//   DialogContent,
//   // DialogHeader,
//   // DialogTitle,
// } from '@workspace/web-ui/components/dialog';
// import { Pill } from 'lucide-react';

// type DosespotModalProps = {
//   isOpen: boolean;
//   onClose: () => void;
//   setIsOpen: () => void;
// };

// const DosespotModal: React.FC<DosespotModalProps> = ({ isOpen, onClose, setIsOpen }) => {
//   return (
//     <>
//            {/* Trigger Button */}
//        <Button
//         onClick={() => setIsOpen()}
//          className="bg-blue-600 w-full text-white px-4 py-2 rounded hover:bg-blue-700 transition flex items-center gap-2"
//        >
//          <Pill className="w-4 h-4" />
//          Assign Medication
//        </Button>
//     <Dialog open={isOpen} onOpenChange={onClose}>
//       <DialogContent className="w-full max-w-4xl">
//         {/* <DialogHeader>
//           <DialogTitle>Dosespot UI</DialogTitle>
//         </DialogHeader> */}

//         <div className="w-full h-[70vh]">
//           <iframe
//             src="https://my.staging.dosespot.com"
//             title="Dosespot"
//             className="w-full h-full border-0"
//           />
//         </div>
//       </DialogContent>
//     </Dialog>
//     </>

//   );
// };

// export default DosespotModal;





import type React from "react"
import { Button } from "@workspace/web-ui/components/button"
import { Pill, Loader2 } from "lucide-react"
import { useDosespotSsoUrlQuery } from "~/features/dashboard/api/refills"
import { toast } from "sonner"

type DosespotButtonProps = {
  userDosespotId?: string
  sessionId?: string
  encounterId?: string
  onSuccess?: () => void
  urgent_care_onboarded?: boolean
  disabled?: boolean // Add disabled prop
  buttonText?: string // Custom button text
}

const DosespotButton: React.FC<DosespotButtonProps> = ({
  userDosespotId,
  sessionId,
  encounterId,
  urgent_care_onboarded,
  onSuccess,
  disabled = false, // Default to false
  buttonText = "Assign Medication", // Default button text
}) => {
  const { refetch, isLoading } = useDosespotSsoUrlQuery(
    userDosespotId,
    sessionId,
    encounterId,
    false, // don't auto-fetch
  )

  const handleClick = async () => {
    if (!userDosespotId || !sessionId || !encounterId) {
      toast.error("Dosespot not available. Ensure patient and session are active", {
        style: {
          background: "#F59E0B",
          color: "#FFFFFF",
          borderColor: "#F59E0B",
        } as React.CSSProperties,
      })
      return
    }

    try {
      const { data, error } = await refetch()
      if (error) throw error

      if (data?.sso_url) {
        window.open(data.sso_url, "_blank", "noopener,noreferrer")
        onSuccess?.()
      } else {
        toast.error("No SSO URL returned from Dosespot", {
          style: {
            background: "#DC2626",
            color: "#FFFFFF",
            borderColor: "#DC2626",
          } as React.CSSProperties,
        })
      }
    } catch (err: any) {
      toast.error(`Failed to load Dosespot: ${err.message ?? "Unknown error"}`, {
        style: {
          background: "#DC2626",
          color: "#FFFFFF",
          borderColor: "#DC2626",
        } as React.CSSProperties,
      })
    }
  }

  // Combine all disabled conditions
  const isDisabled = isLoading || !urgent_care_onboarded || disabled;

  return (
    <Button
      onClick={handleClick}
      disabled={isDisabled}
      className="bg-blue-600 w-full h-[44px] text-white px-4 py-2 rounded hover:bg-blue-700 transition flex items-center gap-2 disabled:opacity-50"
    >
      {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Pill className="w-4 h-4" />}
      {isLoading ? "Opening Dosespot..." : buttonText}
    </Button>
  )
}

export default DosespotButton